module.exports = __webpack_public_path__ + "img/angle_210.ee10f1d3.jpg";